import { computed } from 'vue';

import { productsPerPageByColumnCount } from '@zyro-inc/site-modules/components/blocks/ecommerce/utils';
import { EcommerceProductListScrollBehaviour } from '@hostinger/builder-schema-validator/schema/schemaTypes';

export const useBlockEcommerceProductList = (props) => {
	const viewport = computed(() => (props.isMobileView ? 'mobile' : 'desktop'));
	const blockStyle = computed(() => props.data.settings?.styles);
	const imageHoverEffect = computed(() => props.data.settings?.imageHoverEffect);
	const textColorVars = computed(() => props.data.textColorVars);
	const columnCount = computed(() => props.data[viewport.value]?.columnCount);
	const columnGap = computed(() => props.data[viewport.value]?.columnGap);
	const rowGap = computed(() => props.data[viewport.value]?.rowGap);
	const productCategoryId = computed(() => props.data.productCategoryId);
	const isButtonEnabled = computed(() => props.data.isButtonEnabled ?? false);
	const buttonDisplay = computed(() => props.data.buttonDisplay);
	const buttonText = computed(() => props.data.buttonText);
	const buttonStyle = computed(() => props.data.buttonStyle);
	const buttonType = computed(() => props.data.buttonType);
	const buttonBorderWidth = computed(() => props.data.buttonBorderWidth);
	const ribbonStyle = computed(() => props.data.ribbonStyle);
	const imageRatio = computed(() => props.data.imageRatio);
	const backgroundColor = computed(() => props.data.background.color);
	const isCategoryListEnabled = computed(() => props.data.isCategoryListEnabled);
	const disabledFilterCategoryIds = computed(() => props.data.disabledFilterCategoryIds);
	const isFullWidth = computed(() => props.data.isFullWidth);
	const isTotalProductCountShown = computed(() => props.data.isTotalProductCountShown);
	const isListCentered = computed(() => props.data.isListCentered);
	const isButtonFullWidth = computed(() => props.data.isButtonFullWidth);
	const productSorting = computed(() => ({
		...props.data.productSorting,
		sortingOptions: props.data.productSorting?.sortingOptions?.filter((option) => option.isEnabled),
	}));
	const productSearch = computed(() => props.data.productSearch);
	const productsPerPage = computed(
		() => props.data.productsPerPage || productsPerPageByColumnCount[columnCount.value || 2],
	);
	const scrollBehaviour = computed(() => props.data.scrollBehaviour || EcommerceProductListScrollBehaviour.PAGINATION);
	const isScrollToTopEnabled = computed(() => props.data.isScrollToTopEnabled ?? false);
	const scrollToTopStyle = computed(() => props.data.scrollToTopStyle);

	return {
		textColorVars,
		blockStyle,
		imageHoverEffect,
		columnCount,
		productsPerPage,
		productCategoryId,
		isButtonEnabled,
		buttonDisplay,
		buttonText,
		buttonStyle,
		buttonType,
		buttonBorderWidth,
		ribbonStyle,
		imageRatio,
		backgroundColor,
		isCategoryListEnabled,
		disabledFilterCategoryIds,
		productSorting,
		productSearch,
		isFullWidth,
		isTotalProductCountShown,
		columnGap,
		rowGap,
		isListCentered,
		isButtonFullWidth,
		scrollBehaviour,
		isScrollToTopEnabled,
		scrollToTopStyle,
	};
};
